import { render, staticRenderFns } from "./NavTop.vue?vue&type=template&id=6206bbe4&"
import script from "./NavTop.vue?vue&type=script&lang=js&"
export * from "./NavTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports